// Every api/* helper resolves with the axios error instead of throwing, so a
// failed call reaches the UI as a value rather than via catch. These helpers
// turn any of those shapes into something safe to render: React throws
// "Objects are not valid as a React child" when a raw axios error or a
// validation array of objects reaches JSX, which blanks the whole page.

// An axios error carries `response` only when the server actually answered.
// Without one the request never got there - offline, DNS, timeout or CORS.
export const isNetworkError = result =>
	result instanceof Error && !result.response;

// The API returns `detail` as a plain string, as FastAPI's [{ msg }] array for
// validation failures, or occasionally as something unexpected - `fallback`
// covers that last case so the caller always gets a renderable string.
export const formatErrorDetail = (detail, fallback) => {
	if (typeof detail === 'string' && detail.trim()) return detail;

	if (Array.isArray(detail)) {
		const messages = detail
			.map(item => (typeof item === 'string' ? item : item?.msg))
			.filter(Boolean)
			.join(', ');
		if (messages) return messages;
	}

	return fallback;
};

// Pulls the message out of a rejected call regardless of whether it arrived as
// a returned value or a thrown error.
export const getApiErrorMessage = (result, fallback) =>
	formatErrorDetail(result?.response?.data?.detail, fallback);
